module.exports = __webpack_public_path__ + "img/healthy_soil.66a30f84.png";